import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=68dd3387&scoped=true&"
import script from "./remarks.vue?vue&type=script&lang=js&"
export * from "./remarks.vue?vue&type=script&lang=js&"
import style0 from "./remarks.vue?vue&type=style&index=0&id=68dd3387&lang=scss&scoped=true&"
import style1 from "./remarks.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./remarks.vue?vue&type=style&index=2&id=68dd3387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd3387",
  null
  
)

export default component.exports